import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardContent } from '@/components/ui/card'

/**
 * Loading skeleton for the runs list page.
 * 
 * @example
 * ```tsx
 * {isLoading ? <RunListSkeleton /> : <RunList runs={runs} />}
 * ```
 */
export function RunListSkeleton() {
  return (
    <div className="space-y-4">
      {/* Filters bar */}
      <div className="flex items-center gap-4">
        <Skeleton className="h-9 w-48" />
        <Skeleton className="h-9 w-32" />
        <Skeleton className="h-9 w-40" />
        <div className="flex-1" />
        <Skeleton className="h-9 w-24" />
      </div>

      {/* Table header */}
      <div className="flex items-center gap-4 px-4 py-2 bg-muted/50 rounded-lg">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-48" />
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-4 w-24" />
        <div className="flex-1" />
        <Skeleton className="h-4 w-20" />
      </div>

      {/* Run rows */}
      {Array.from({ length: 10 }).map((_, i) => (
        <Card key={i}>
          <CardContent className="p-4">
            <div className="flex items-center gap-4">
              <Skeleton className="h-5 w-16" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-48" />
              </div>
              <Skeleton className="h-4 w-24" />
            </div>
          </CardContent>
        </Card>
      ))}

      {/* Pagination */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-32" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-9" />
          <Skeleton className="h-9 w-9" />
          <Skeleton className="h-9 w-9" />
        </div>
      </div>
    </div>
  )
}
